import { Component } from 'react'
import Utility from './Utility';
import { connect } from 'react-redux'

class Statistics extends Component {
	constructor(props) {
		super(props);

		this.startedPlaying = false;

		this.timeRanges = [];
		this.events = [];

		this.url = this.props.data.recording.statsURL;
		this.viewerUID = this.props.data.recording.viewerUID;
		this.duration = this.props.data.recording.info.movie_exported_duration;

		this.quartileLength = this.duration / 4;
		this.endFirstQuartile = this.quartileLength;
		this.endSecondQuartile = this.quartileLength * 2;
		this.endThirdQuartile = this.quartileLength * 3;
		this.endFourthQuartile = this.duration * 1;

		// Calculate
		this.currentQuartile = this.getCurrentQuartile(this.props.data.initialTime);

		// Track internal operation of the stats model
		this.errorCount = 0;
		this.pausedCount = 0;
		this.started = false;

		this.sendPostInterval = 0; // default not to throttle
		this.lastUpdateSendTime = 0; // always send our first checkin

		clearInterval(this.props.statsIID);
		this.statsIID = Utility.interval(this.props.data.statsInterval, this.checkIn);
		this.sendPostInterval = this.props.data.sendPostInterval;
		this.checkIn(true);

		this.heartbeatPaused = false;
		this.pauseHeartbeatTID = null;
	}

	getCurrentQuartile = (time) => {
		if (time <= this.endFirstQuartile) {
			return 0;
		} else if (time <= this.endSecondQuartile) {
			return 1;
		} else if (time <= this.endThirdQuartile) {
			return 2;
		}

		return 3;
	}

	componentDidMount() {
		document.addEventListener('player.statsevent', this.newEvent);
		window.addEventListener('beforeunload', this.beforeUnload);

		document.addEventListener('fullscreenchange', this.fullscreenChangeHandler);
	}

	componentWillUnmount() {
		document.removeEventListener('player.statsevent', this.newEvent);
		window.removeEventListener('beforeunload', this.beforeUnload);

		document.removeEventListener('fullscreenchange', this.fullscreenChangeHandler);
	}

	beforeUnload = (ev) => {
		let seconds = this.secondsWatched(),
			percent = this.percentWatched();

		let data = {
			viewer_uid: this.viewerUID,
			seconds: seconds,
			percent: percent,
			mediaTime: this.props.dynamic.currentTime,
			checkin: true,
			player: "{\"action\": \"windowclose\"}"
		};

		data.events = JSON.stringify(this.events);
		this.events = [];

		Utility.callPost(this.url, data, (xhr) => {
			// do nothing
		});

		// ev.returnValue = 'Are you sure you want to close the window?';
		// return "Are you sure you want to close the window?"
		// Delay for 2 seconds
		let start = new Date().getTime();
		while (new Date().getTime() < start + 2000);
  	}

  	newEvent = (ev) => {
  		const eventTime = Math.floor(Date.now() / 1000);

		const eventMapper = {
			player_increase_source: 'ChangedSize',
			player_decrease_source: 'ChangedSize',
			player_show_captions: 'EnabledClosedCaptioning',
			player_hide_captions: 'DisabledClosedCaptioning',
			player_enter_fullscreen: 'EnteredFullScreen',
			player_exit_fullscreen: 'ExitedFullScreen',
			player_change_playback_rate: 'ChangedSpeed',
			player_pause: 'Paused',
			player_resume: 'Resumed',
			player_started: 'Started',
			player_ended: 'Ended',
			player_unmute: 'Unmuted',
			player_mute: 'Muted',
			player_seeked: 'JumpedTo',
			player_go_backward_10_seconds: 'JumpedTo',
			player_go_forward_10_seconds: 'JumpedTo',
			player_change_volume: 'ChangedVolume'
		}

		if (eventMapper[ev.detail.event_name]) {
			// Player always loads paused, so when we get our first player_resume event,
			// convert it to a player_started event
			if (this.startedPlaying === false && ev.detail.event_name === 'player_resume') {
				ev.detail.event_name = 'player_started';
				this.startedPlaying = true;
			}

			// Only allow it to send one JumpedTo a second
			if (ev.detail.event_name === 'player_seeked') {
				if (this.events.length > 0 && this.events[this.events.length-1].action === 'JumpedTo' && this.events[this.events.length-1].eventTime === eventTime) {
					return;
				}
			}

			this.events.push({
				action: eventMapper[ev.detail.event_name],
				mediaTime: ev.detail.current_time,
				eventTime: eventTime
			});
		}
  	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.dynamic.currentTime !== prevProps.dynamic.currentTime) {
			this.heartbeat();
		}

		if (this.props.data.ended !== prevProps.data.ended) {
    		if (this.props.data.ended === true) {
				this.logEnd(this.props.dynamic.currentTime);
				this.report();
			}
		}
	}

	heartbeat = () => {
		if (this.started === false) {
			this.started = true;
			this.logStart(this.props.dynamic.currentTime);
		}

		if (this.heartbeatPaused === true) {
			return;
		}

		let currentQuartile = this.getCurrentQuartile(this.props.dynamic.currentTime);

		if (currentQuartile !== this.currentQuartile) {
			this.events.push({
				action: 'StreamedToTime',
				mediaTime: this.props.dynamic.currentTime,
				eventTime: Math.floor(Date.now() / 1000)
			});

			console.log('CurrentQuartile switched from', this.currentQuartile, 'to', currentQuartile);

			this.currentQuartile = currentQuartile;
		}
	}

	pauseHeartbeat = () => {
		console.log('pauseHeartbeat');
		this.heartbeatPaused = true;
		clearTimeout(this.pauseHeartbeatTID);
		this.pauseHeartbeatTID = Utility.delay(1000, () => { this.heartbeatPaused = false });
	}

	playHeartbeat = () => {
		this.heartbeatPaused = false;
		this.heartbeat();
	}

	report = () => {
		var seconds = this.secondsWatched(),
			percent = this.percentWatched();

		var data = {
			viewer_uid: this.viewerUID,
			seconds: seconds,
			percent: percent
		}

		Utility.callPost(this.url, data, (xhr) => {
			// do nothing
		});
	}

	// Called in a setInterval call, every 15 seconds
	// Also called once the very first time this interval is created
	checkIn = (force = false) => {
		console.log('Checkin');
		console.log(this.events);

		var seconds = 0,
			sendUpdate = false,
			time = this.props.dynamic.currentTime;

		if (force === false) {
			this.logEnd(time);
			this.logStart(time);
			seconds = this.secondsWatched();
		}

		console.log('Checkin', seconds)

		if (force === true || seconds > 0) {
			var playerInfo = {
				playing: !this.props.data.paused,
				mediaTime: time || 'unknown',
				error: '',
				streamingServer: 0,
				type: 'React Viewer'
			};

			var data = {
				viewer_uid: this.viewerUID,
				seconds: seconds,
				percent: this.percentWatched(),
				checkin: true,
				player: JSON.stringify(playerInfo)
			};

			if (playerInfo.playing === true) {
				// always send when playing
				sendUpdate = true;
				this.pausedCount = 0;
			} else {
				// Player is not playing
				if (this.pausedCount === 0) {
					sendUpdate = true;
					this.pausedCount++;
				} else {
					// Do not send if the pausedCount is > 0
					if (this.pausedCount >= 4) {
						// reset so on the next update interval it sends
						this.pausedCount = 0;
					} else {
						this.pausedCount++;
					}
				}
			}

			if (this.statsErrorCount > 8) {
				// if we get more than 8 consecutive errors, stop sending updates
				sendUpdate = false;
			}

			// Throttle our checkins?
			if (Date.now() - this.lastUpdateSendTime < this.sendPostInterval) {
				sendUpdate = false;
			} else {
				// send now
				this.lastUpdateSendTime = Date.now();
			}

			if (sendUpdate === true) {
				data.events = JSON.stringify(this.events);
				this.events = [];

				Utility.callPost(this.url, data, (xhr) => {
					if (xhr.status !== 200) {
						this.statsErrorCount++;
					} else {
						this.statsErrorCount = 0;
					}
				});
			}
		}
	}

	// Called at beginning of heartbeat function - TODO
	// Called after seeking with a custom seek event
	logStart = (time) => {
		if (0 <= time && time <= this.duration) {
			this.lastStart = new Date().getTime();

			this.currentTimeRange = {
				start: time,
				end: time
			}
		}
	}

	// Called after seeking with a custom seek event
	// Called when the video reaches the end
	logEnd = (time) => {
		if (0 <= time && time <= this.duration) {
			if (this.currentTimeRange && time > this.currentTimeRange.start) {
				// one more sanity check to make sure the specified amount of
				// time watched was even possible
				var now = new Date().getTime();

				if ((now - this.lastStart)/1000 >= time - this.currentTimeRange.start - 5) {
					this.currentTimeRange.end = time;
					this.timeRanges.push(this.currentTimeRange);
					this.currentTimeRange = null;
				}
			}
		}
	}

	// sum of all watched ranges (including overlap)
	secondsWatched = () => {
		var total = 0;

		for (var i = this.timeRanges.length - 1; i >= 0; i--) {
			total += this.timeRanges[i].end - this.timeRanges[i].start;
		}

		// round to nearest whole second
		return Math.round(total);
	}

	// assumes the timeRanges array is formatted properly
	// (i.e. each range has both start and end properties and the start is
	// always <= end)
	percentWatched = () => {
		// copy the array
		var ranges = this.timeRanges.slice();

		if (ranges.length < 1) {
			return 0;
		}

		// sort start ASC, end DESC
		ranges.sort(function(a, b) {
			return a.start - b.start || b.end - b.start;
		});

		var range = ranges[0];
		var total = range.end - range.start;

		var duration, i, overlap;

		if (ranges.length > 1) {
			for (i = 1; i < ranges.length; i++) {
				// if the start time is the same, ignore it since we sorted
				// so the longest will be first with the same start time
				if (range.start !== ranges[i].start) {
					// add the duration of the new range minus its overlap with the prev
					duration = ranges[i].end - ranges[i].start;
					overlap = Math.min(range.end, ranges[i].end) - Math.max(range.start, ranges[i].start);
					// if overlap is negative, there is no overlap
					if (overlap < 0) {
						overlap = 0;
					}
					total += duration - overlap;
					range = ranges[i];
				}
			}
		}

		// round to the nearest percent
		return Math.round(100 * total / this.duration);
	}

	fullscreenChangeHandler = () => {
		console.log('fullscreenChangeHandler');
		if (
			document.fullscreenElement ||
			document.webkitFullscreenElement ||
			document.mozFullScreenElement ||
			document.msFullscreenElement
		) {
			this.logEventHandler('player_enter_fullscreen');
		} else {
			this.logEventHandler('player_exit_fullscreen');
		}
	}

	logEventHandler = (event, params = {}) => {
		Utility.logUserInteraction(event, params, { current_time: this.props.dynamic.currentTime });
	}

	render() {
		return null;
	}
}

const mapStateToProps = (state) => ({
	dynamic: state.dynamic
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(Statistics);